import React from 'react'
import BaseElfWidget from './BaseElfWidget'
import { homepageReviewsWidgetConfig } from '../../config/elfSight'

type HomepageReviewWidgetProps = {
  reviewHeading?: string
}

const HomepageReviewWidget = ({ reviewHeading } : HomepageReviewWidgetProps ) : JSX.Element => {
  const {id, name} = homepageReviewsWidgetConfig

  return (
    <div className="max-w-[1280px] mx-auto overflow-hidden sm:pt-9 pb-7 md:pt-[42px] md:pb-[50px] sm:px-4 md:px-6 sm:min-h-[350px] lg:min-h-[450px]">
      <h2 className="max-w-5xl mx-auto text-center font-normal sm:text-2xl sm:pb-4 md:pb-16 md:text-[44px] text-deepSleepBlue md:!leading-[52px]">{reviewHeading || `Aeroflow Is The Trusted Choice For CPAP Supplies`}</h2>
      <BaseElfWidget widgetId={id} widgetName={name} />
    </div>
  )
}

export default HomepageReviewWidget
